import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class CamionesRechazadosPesado {
  getCamionesRechazadosEnPesado () {
    const axios = getAxiosInstance()
    const promise = axios.get('consulta_rechazo_cea_en_pesado_listado')
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data })
  }

  getCamionesRechazadosEnPesadoVigente () {
    const axios = getAxiosInstance()
    const promise = axios.get('consulta_rechazo_cea_en_pesado_vigente')
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data })
  }
}

export default CamionesRechazadosPesado
